import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { smooth } from './utils/smooth';
import { link } from './utils/link';
import Adm from './components/adm';

import HomeView from './views/HomeView';
const App = () => {
  useEffect(() => {
    console.log(
      '%c MOSU Seoul ',
      "font-family: 'Courier New', monospace; font-size: 20px; font-weight: bold; color: #333; background: #f5f5f5; padding: 8px 16px; border: 2px solid #333; border-radius: 4px; text-transform: uppercase;"
    );

    console.log('Create by @YaongPainter');

    smooth();
    link();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeView />}></Route>
        <Route path="/adm" element={<Adm />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
